export default __webpack_public_path__ + "static/media/1003.d05beb95.png";